import { config as asConfig } from '../boaxel/AdjustableConfig';
import { metricToImperial } from '../../util/measures';
import { selectUseMetric } from '../../state/dexfSettings/dexfSettingsSelectors';
import store from '../../state';

export function getWidthText(itemContext) {
  function localUnit(sectionWidth) {
    const useMetricMeasures = selectUseMetric(store.getState());
    return useMetricMeasures
      ? Math.ceil(sectionWidth / 10)
      : metricToImperial(sectionWidth).onlyInches;
  }

  if (itemContext.item.width > asConfig.section.maxWidth) {
    return localUnit(itemContext.item.width);
  }
  const min = localUnit(asConfig.section.minWidth);
  const max = localUnit(asConfig.section.maxWidth);
  return `${min} - ${max}`;
}
